import React, { useRef, useEffect, useState } from "react";

const ScrollZoomVideo = () => {
  const videoRef = useRef(null);
  const [scale, setScale] = useState(1);
  const videoRef1 = useRef(null);
  const [isMuted, setIsMuted] = useState(true);




  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const maxScroll = document.body.scrollHeight - window.innerHeight;

      // Increase zoom intensity: from 1x to 3x
      const zoomIntensity = 4; // 2 means max zoom will be 3x (1 + 2)
      const newScale = 1 + (scrollTop / maxScroll) * zoomIntensity;
      setScale(newScale);

      // Optional: sync video playback to scroll
      if (videoRef.current) {
        const duration = videoRef.current.duration || 1;
        videoRef.current.currentTime = duration * (scrollTop / maxScroll);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


    const handleCanPlay = () => {
    const video1 = videoRef1.current;
    if (video1) {
      const playPromise = video1.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            // autoplay started successfully
          })
          .catch((error) => {
            console.warn("Autoplay prevented:", error);
          });
      }
    }
  };

  return (
    <div style={{ height: "300vh" }}> {/* Makes the page scrollable */}
      <video
        ref={videoRef1}
        autoPlay
         muted={isMuted}
        loop
        playsInline
        onCanPlayThrough={handleCanPlay}
        style={{
          position: "sticky",
          top: "50%",
          left: "50%",
          transform: `translate(-50%, -50%) scale(${scale})`,
          width: "20%",
          maxWidth: "1200px",
          borderRadius: "12px",
        }}

      >
       <source src="/assets/videos/human_performance.mp4" type="video/mp4" />
      </video>
       <button
      onClick={() => setIsMuted(!isMuted)}
      style={{
        position: "fixed",
        bottom: "40px",
        right: "40px",
        background: "rgba(0,0,0,0.6)",
        color: "#fff",
        border: "none",
        borderRadius: "8px",
        padding: "12px 18px",
        cursor: "pointer",
      }}
    >
     {(isMuted) ? "🔇 Mute" : " 🔊 Unmute"}
    </button>
    </div>
  );
};

export default ScrollZoomVideo;